import effectManager from '../../module/effect';

let effect = new effectManager();

export default class toggleManager {
    constructor() {

        this.$container = document.querySelectorAll(".p-faq-toggle");
        this.$target = document.querySelectorAll(".p-faq-toggle dt");
        this.$contents = document.querySelectorAll(".p-faq-toggle dd");

        this.status = {
            open: [],
        }
        this.scroll;
        this.tab;

    }
    init(scroll, tab){

        this.scroll = scroll;
        this.tab = tab;


        // class付与
        for(let i=0; i<this.$contents.length; i++){
            this.$contents[i].classList.add('is-close');
        }

        //
        for(let i=0; i<this.$target.length; i++){
            this.status.open[i] = false;
            this.$target[i].addEventListener("click",(event)=> {
                event.preventDefault();

                if (!this.status.open[i]) {
                    this.status.open[i] = true;
                    this.open(event.target);

                } else {
                    this.status.open[i] = false;
                    this.close(event.target);
                }
                this.scroll.resize();
                this.tab.resize();

            }, {passive: false});
        }

    }
    open(select){
        // console.log(this.status.open);
        let _$a = select;
        let _$dd = _$a.parentNode.nextElementSibling;

        TweenMax.set(_$dd, {opacity: 0});

        _$a.classList.add('is-open');
        _$dd.classList.remove('is-close');


        // 表示
        TweenMax.to(_$dd, 0.3, {
            ease: Power3.easeIn,
            opacity: 1,
            onComplete: ()=>{
                this.scroll.resize();
                this.tab.resize();
            },
        });

    }
    close(select){
        // console.log(this.status.open);
        let _$a = select;
        let _$dd = _$a.parentNode.nextElementSibling;

        _$a.classList.remove('is-open');
        _$dd.classList.add('is-close');

    }

}